export default theme => {
  return {
    container: {
        height: '100%',
        backgroundColor: theme.palette.grey[100],
      borderBottom: `1px solid ${theme.palette.grey[400]}`
    }
  }
}
